import { SESSION_ID_KEY } from '@web/auth';

import {
  createTRPCQueryUtils,
  createTRPCReact,
  httpLink,
  loggerLink,
  splitLink,
  unstable_httpSubscriptionLink,
} from '@trpc/react-query';

import {
  EventSourcePolyfill,
  EventSourcePolyfillInit,
} from 'event-source-polyfill';

import type { AppRouter } from '@server/trpc/trpc.router';
import { trpcPath } from '@shared/constants';
import { queryClient } from '@web/lib/react-query';

// polyfill EventSource
globalThis.EventSource = EventSourcePolyfill as unknown as typeof EventSource;

export const trpc = createTRPCReact<AppRouter>();

const url = trpcPath;

const headers = () => {
  const sessionId = sessionStorage.getItem(SESSION_ID_KEY);
  return sessionId ? { authorization: `bearer ${sessionId}` } : {};
};

export const trpcClient = trpc.createClient({
  links: [
    // adds pretty logs to your console in development and logs errors in production
    loggerLink(),

    splitLink({
      // uses the httpSubscriptionLink for subscriptions
      condition: (op) => op.type === 'subscription',

      true: unstable_httpSubscriptionLink({
        url,
        eventSourceOptions: () => {
          return {
            headers: headers(),
            heartbeatTimeout: Number.MAX_SAFE_INTEGER,
          } as EventSourcePolyfillInit;
        },
      }),

      false: httpLink({
        url,
        headers,
      }),
    }),
  ],
});

export const trpcQueryUtils = createTRPCQueryUtils({
  queryClient,
  client: trpcClient,
});
